import { render, staticRenderFns } from "./PositionWatchlist.vue?vue&type=template&id=e376d84a&scoped=true&"
import script from "./PositionWatchlist.vue?vue&type=script&lang=js&"
export * from "./PositionWatchlist.vue?vue&type=script&lang=js&"
import style0 from "./PositionWatchlist.vue?vue&type=style&index=0&id=e376d84a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e376d84a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VImg,VSimpleTable,VSpacer,VTooltip})
